import Vue from 'vue'
import Vuex from 'vuex'
import AWS from 'aws-sdk/global'
import generalLogin from './lib/generalLogin.js'
import HomAptCognito from './lib/cognitoLogin.js'
import HomAptFacebook from './lib/facebookLogin.js'
import apigClientFactory from 'aws-api-gateway-client'
import createPersistedState from 'vuex-persistedstate'
import defaultValues from './lib/defaultValues.js'
import products from './modules/products'
import property from './modules/property'
import business from './modules/business'
import user from './modules/user'
import lender from './modules/lender'
import realtor from './modules/realtor'
import serviceProvider from './modules/serviceProvider'
import homeSearch from './modules/homeSearch'
import loginModal from './modules/loginModal'
import marketSearch from './modules/marketSearch'
import router from '../router/index.js'
import uuid from 'uuid'

AWS.config.region = window.CONFIG.Region
Vue.use(Vuex)

export const store = new Vuex.Store({
  plugins: [
    createPersistedState({
      // CAREFUL WITH THIS
      reducer: function (state) {
        return {
          cognitoId: state.cognitoId,
          idProvider: state.idProvider,
          accessKeyId: state.accessKeyId,
          secretAccessKey: state.secretAccessKey,
          sessionToken: state.sessionToken,
          expireTime: state.expireTime,
          products: state.products,
          property: state.property,
          business: state.business,
          user: state.user,
          lender: state.lender,
          realtor: state.realtor,
          serviceProvider: state.serviceProvider
        }
      }
    })
  ],
  modules: {
    products,
    property,
    business,
    user,
    lender,
    realtor,
    serviceProvider,
    homeSearch,
    loginModal,
    marketSearch
  },
  state: {
    cognitoId: defaultValues.cognitoId,
    idProvider: defaultValues.idProvider,
    accessKeyId: defaultValues.accessKeyId,
    secretAccessKey: defaultValues.secretAccessKey,
    sessionToken: defaultValues.sessionToken,
    expireTime: defaultValues.expireTime
  },
  getters: {
    getCognitoId: state => {
      return state.cognitoId
    },
    getIdProvider: state => {
      return state.idProvider
    },
    getAccessKeyId: state => {
      return state.accessKeyId
    },
    getSecretAccessKey: state => {
      return state.secretAccessKey
    },
    getSessionToken: state => {
      return state.sessionToken
    },
    getExpireTime: state => {
      if (typeof state.expireTime === 'string' || state.expireTime instanceof String) return new Date(state.expireTime)
      else return state.expireTime
    },
    getBlogApigClientFactory: state => {
      return apigClientFactory.newClient({
        invokeUrl: window.CONFIG.BlogRestApiRootPath,
        accessKey: state.accessKeyId,
        secretKey: state.secretAccessKey,
        sessionToken: state.sessionToken,
        region: window.CONFIG.Region
      })
    },
    getBusinessApigClientFactory: state => {
      return apigClientFactory.newClient({
        invokeUrl: window.CONFIG.BusinessRestApiRootPath,
        accessKey: state.accessKeyId,
        secretKey: state.secretAccessKey,
        sessionToken: state.sessionToken,
        region: window.CONFIG.Region
      })
    },
    getCouponApigClientFactory: state => {
      return apigClientFactory.newClient({
        invokeUrl: window.CONFIG.CouponRestApiRootPath,
        accessKey: state.accessKeyId,
        secretKey: state.secretAccessKey,
        sessionToken: state.sessionToken,
        region: window.CONFIG.Region
      })
    },
    getDataTransactionApigClientFactory: state => {
      return apigClientFactory.newClient({
        invokeUrl: window.CONFIG.DataTransactionRestApiRootPath,
        accessKey: state.accessKeyId,
        secretKey: state.secretAccessKey,
        sessionToken: state.sessionToken,
        region: window.CONFIG.Region
      })
    },
    getEmailApigClientFactory: state => {
      return apigClientFactory.newClient({
        invokeUrl: window.CONFIG.EmailRestApiRootPath,
        accessKey: state.accessKeyId,
        secretKey: state.secretAccessKey,
        sessionToken: state.sessionToken,
        region: window.CONFIG.Region
      })
    },
    getHomFaxApigClientFactory: state => {
      return apigClientFactory.newClient({
        invokeUrl: window.CONFIG.HomFaxRestApiRootPath,
        accessKey: state.accessKeyId,
        secretKey: state.secretAccessKey,
        sessionToken: state.sessionToken,
        region: window.CONFIG.Region
      })
    },
    getImageApigClientFactory: state => {
      return apigClientFactory.newClient({
        invokeUrl: window.CONFIG.ImageRestApiRootPath,
        accessKey: state.accessKeyId,
        secretKey: state.secretAccessKey,
        sessionToken: state.sessionToken,
        region: window.CONFIG.Region
      })
    },
    getLenderApigClientFactory: state => {
      return apigClientFactory.newClient({
        invokeUrl: window.CONFIG.LenderRestApiRootPath,
        accessKey: state.accessKeyId,
        secretKey: state.secretAccessKey,
        sessionToken: state.sessionToken,
        region: window.CONFIG.Region
      })
    },
    getMessageApigClientFactory: state => {
      return apigClientFactory.newClient({
        invokeUrl: window.CONFIG.MessageRestApiRootPath,
        accessKey: state.accessKeyId,
        secretKey: state.secretAccessKey,
        sessionToken: state.sessionToken,
        region: window.CONFIG.Region
      })
    },
    getNotificationApigClientFactory: state => {
      return apigClientFactory.newClient({
        invokeUrl: window.CONFIG.NotificationRestApiRootPath,
        accessKey: state.accessKeyId,
        secretKey: state.secretAccessKey,
        sessionToken: state.sessionToken,
        region: window.CONFIG.Region
      })
    },
    getPaymentApigClientFactory: state => {
      return apigClientFactory.newClient({
        invokeUrl: window.CONFIG.PaymentRestApiRootPath,
        accessKey: state.accessKeyId,
        secretKey: state.secretAccessKey,
        sessionToken: state.sessionToken,
        region: window.CONFIG.Region
      })
    },
    getPropertyApigClientFactory: state => {
      return apigClientFactory.newClient({
        invokeUrl: window.CONFIG.PropertyRestApiRootPath,
        accessKey: state.accessKeyId,
        secretKey: state.secretAccessKey,
        sessionToken: state.sessionToken,
        region: window.CONFIG.Region
      })
    },
    getRealtorApigClientFactory: state => {
      return apigClientFactory.newClient({
        invokeUrl: window.CONFIG.RealtorRestApiRootPath,
        accessKey: state.accessKeyId,
        secretKey: state.secretAccessKey,
        sessionToken: state.sessionToken,
        region: window.CONFIG.Region
      })
    },
    getReviewApigClientFactory: state => {
      return apigClientFactory.newClient({
        invokeUrl: window.CONFIG.ReviewRestApiRootPath,
        accessKey: state.accessKeyId,
        secretKey: state.secretAccessKey,
        sessionToken: state.sessionToken,
        region: window.CONFIG.Region
      })
    },
    getServiceProviderApigClientFactory: state => {
      return apigClientFactory.newClient({
        invokeUrl: window.CONFIG.ServiceProviderRestApiRootPath,
        accessKey: state.accessKeyId,
        secretKey: state.secretAccessKey,
        sessionToken: state.sessionToken,
        region: window.CONFIG.Region
      })
    },
    getTaskApigClientFactory: state => {
      return apigClientFactory.newClient({
        invokeUrl: window.CONFIG.TaskRestApiRootPath,
        accessKey: state.accessKeyId,
        secretKey: state.secretAccessKey,
        sessionToken: state.sessionToken,
        region: window.CONFIG.Region
      })
    },
    getUserApigClientFactory: state => {
      return apigClientFactory.newClient({
        invokeUrl: window.CONFIG.UserRestApiRootPath,
        accessKey: state.accessKeyId,
        secretKey: state.secretAccessKey,
        sessionToken: state.sessionToken,
        region: window.CONFIG.Region
      })
    },
    getVersionCheckApigClientFactory: state => {
      return apigClientFactory.newClient({
        invokeUrl: window.CONFIG.VersionCheckRestApiRootPath,
        accessKey: state.accessKeyId,
        secretKey: state.secretAccessKey,
        sessionToken: state.sessionToken,
        region: window.CONFIG.Region
      })
    }
  },
  mutations: {
    updateCognitoId (state, cognitoId) {
      state.cognitoId = cognitoId
    },
    updateIdProvider (state, idProvider) {
      state.idProvider = idProvider
    },
    updateAccessKeyId (state, accessKeyId) {
      state.accessKeyId = accessKeyId
    },
    updateSecretAccessKey (state, secretAccessKey) {
      state.secretAccessKey = secretAccessKey
    },
    updateSessionToken (state, sessionToken) {
      state.sessionToken = sessionToken
    },
    updateExpireTime (state, expireTime) {
      state.expireTime = expireTime
    }
  },
  actions: {
    async unauthenticatedLogin ({ commit, dispatch }) {
      var result
      var authData = {
        loginType: 'email',
        userName: uuid.v4() + '@homapt.com',
        password: 'ABCdefg!@#123',
        idProvider: 'cognito'
      }
      try {
        await HomAptCognito.signUpCognito(authData, true)
        result = await HomAptCognito.unauthLoginCognito(authData.userName, authData.password)
        generalLogin.setAWSCredentials('cognito', result.getIdToken().getJwtToken(), true)
        result = await generalLogin.refreshAWSCredentials()
        generalLogin.setFromResult(commit, result)
        dispatch('refreshLogin')
      } catch (error) {
        dispatch('logOut')
        throw error
      }
    },
    async authenticatedLogin ({ commit, dispatch }, authData) {
      var result
      var idProvider = authData.idProvider
      commit('updateIdProvider', idProvider)
      if (idProvider === 'cognito') {
        try {
          result = await HomAptCognito.loginCognito(authData.userName, authData.password)
          generalLogin.setAWSCredentials(idProvider, result.getIdToken().getJwtToken())
          result = await generalLogin.refreshAWSCredentials()
          generalLogin.setFromResult(commit, result)
          await dispatch('business/createUser')
          await dispatch('business/getUserAttributes')
          dispatch('refreshLogin')
        } catch (error) {
          dispatch('logOut')
          throw error
        }
      } else if (idProvider === 'facebook') {
        try {
          result = await HomAptFacebook.checkFacebookLoginState()
          if (result.status === 'connected') {
            generalLogin.setAWSCredentials(idProvider, result.authResponse.accessToken)
            result = await generalLogin.refreshAWSCredentials()
          } else {
            result = await HomAptFacebook.loginFacebook()
          }
          if (!result.sessionToken) {
            generalLogin.setAWSCredentials(idProvider, result.authResponse.accessToken)
            result = await generalLogin.refreshAWSCredentials()
          }
          generalLogin.setFromResult(commit, result)
          await dispatch('business/createUser')
          await dispatch('business/getUserAttributes')
          dispatch('refreshLogin')
        } catch (error) {
          dispatch('logOut')
          throw error
        }
      } else if (idProvider === 'google') {
        try {
          result = await window.HomAptAuth2.signIn()
          result = await result.getAuthResponse(true)
          generalLogin.setAWSCredentials(idProvider, result.id_token)
          result = await generalLogin.refreshAWSCredentials()
          generalLogin.setFromResult(commit, result)
          await dispatch('business/createUser')
          await dispatch('business/getUserAttributes')
          dispatch('refreshLogin')
        } catch (error) {
          dispatch('logOut')
          throw error
        }
      }
      if ((this.getters['business/profileIsComplete'].profileComplete === false) && (this.getters['user/getUserType'] === 'business')) {
        router.replace(this.getters['business/profileIsComplete'].incompletePath)
      }
      this.dispatch('user/getNotifications')
    },
    refreshLogin ({ commit, dispatch }) {
      var result
      var idProvider = this.getters.getIdProvider
      if (!this.getters.getSecretAccessKey) return
      var currentTimeMilSeconds = new Date().getTime()
      var expireTimeMilSeconds = this.getters.getExpireTime.getTime()
      var timeUntilRefresh = (expireTimeMilSeconds - currentTimeMilSeconds)
      if (timeUntilRefresh <= 0) {
        dispatch('logOut')
        return
      }
      setTimeout(async () => {
        // Unauthenticated user
        if (!idProvider) {
          try {
            generalLogin.setAWSCredentials()
            result = await generalLogin.refreshAWSCredentials()
            generalLogin.setFromResult(commit, result)
            dispatch('refreshLogin')
          } catch (error) {
            console.log(error)
            dispatch('logOut')
          }
        } else if (idProvider === 'cognito') {
          try {
            result = await HomAptCognito.refreshCognito()
            generalLogin.setAWSCredentials(idProvider, result.getIdToken().getJwtToken())
            result = await generalLogin.refreshAWSCredentials()
            generalLogin.setFromResult(commit, result)
            dispatch('refreshLogin')
          } catch (error) {
            console.log(error)
            dispatch('logOut')
          }
        } else if (idProvider === 'facebook') {
          try {
            result = await HomAptFacebook.checkFacebookLoginState()
            if (result.status === 'connected') {
              generalLogin.setAWSCredentials(idProvider, result.authResponse.accessToken)
              result = await generalLogin.refreshAWSCredentials()
            } else {
              throw Error('Not connected to facebook')
            }
            generalLogin.setFromResult(commit, result)
            dispatch('refreshLogin')
          } catch (error) {
            console.log(error)
            dispatch('logOut')
          }
        } else if (idProvider === 'google') {
          try {
            var googleUser = window.HomAptAuth2.currentUser.get()
            result = await googleUser.reloadAuthResponse()
            generalLogin.setAWSCredentials(idProvider, result.id_token)
            result = await generalLogin.refreshAWSCredentials()
            generalLogin.setFromResult(commit, result)
            dispatch('refreshLogin')
          } catch (error) {
            console.log(error)
            dispatch('logOut')
          }
        }
      }, timeUntilRefresh)
    },
    async logOut ({ commit, dispatch }) {
      var result
      var idProvider = this.getters.getIdProvider
      if (!['/lendersignup', '/realtorsignup', '/serviceprovidersignup'].includes(router.currentRoute.path)) {
        router.replace('/')
      }
      if (idProvider === 'cognito') {
        try {
          await HomAptCognito.logoutCognito()
          generalLogin.clearCredentials(commit)
        } catch (error) {
          generalLogin.clearCredentials(commit)
          console.log(error)
        }
      } else if (idProvider === 'facebook') {
        try {
          result = await HomAptFacebook.checkFacebookLoginState()
          if (result.status === 'connected') {
            await HomAptFacebook.logoutFacebook()
            generalLogin.clearCredentials(commit)
          } else {
            generalLogin.clearCredentials(commit)
            return null
          }
        } catch (error) {
          generalLogin.clearCredentials(commit)
          console.log(error)
        }
      } else if (idProvider === 'google') {
        try {
          await window.HomAptAuth2.signOut()
          generalLogin.clearCredentials(commit)
        } catch (error) {
          generalLogin.clearCredentials(commit)
          console.log(error)
        }
      } else {
        generalLogin.clearCredentials(commit)
      }
    },
    async deleteUser ({ commit, dispatch }) {
      var client = this.getters.getUserApigClientFactory
      var params = {}
      var pathTemplate = '/users'
      var method = 'DELETE'
      var additionalParams = {}
      var body = {}
      var idProvider = this.getters.getIdProvider
      try {
        if (idProvider === 'cognito') {
          HomAptCognito.deleteUser()
        }
        client.invokeApi(params, pathTemplate, method, additionalParams, body)
      } catch (error) {
        console.log(error)
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js